module.exports = __webpack_public_path__ + "img/CIMG1135.a3122a1c.jpg";